import { isObject, isString } from 'src/helpers';
import { AdminSorts, isAdminSorts } from '../types';
import { IApiCompany } from 'src/models/company/types';
import { QueryResult, Reference } from '@apollo/client';
import { AdminCompaniesData } from '.';

export enum AdminCompaniesSearchParams {
  name = 'name',
  id = 'id',
  sortBy = 'sortBy'
}
export type AdminCompaniesCached = {
  count: number;
  companies: Reference[];
};
export type AdminCompaniesDataCached = {
  value: AdminCompaniesCached;
  variables: Omit<ApiAdminCompaniesVars, 'searchOptions'> & ApiAdminCompaniesSearchVars;
};
export type ApiAdminCompaniesSortVars = { field: string; direction: string };
export type ApiAdminCompaniesSearchVars = { id?: string; name?: string };
export type ApiAdminCompaniesVars = ApiAdminCompaniesSearchVars & {
  amount: number;
  offset: number;
  sortBy?: ApiAdminCompaniesSortVars;
};

export interface AdminCompaniesSortVars {
  column: AdminCompaniesSortField;
  sort: AdminSorts;
}
export type AdminCompaniesSearchVars = ApiAdminCompaniesSearchVars;
export type AdminCompaniesVars = AdminCompaniesSearchVars & { sortBy?: AdminCompaniesSortVars };
export type UseAdminCompaniesVars = [
  { args: AdminCompaniesVars; vars: ApiAdminCompaniesVars; initArgs: AdminCompaniesVars },
  (args: Partial<AdminCompaniesVars>) => void
];
export interface ApiAdminCompaniesResponse {
  getCompanies: ApiAdminCompaniesResponseData;
}
export interface ApiAdminCompaniesResponseData {
  count: number;
  companies: IApiCompany[];
}
export interface UseAdminCompanies extends Omit<QueryResult<ApiAdminCompaniesResponse, ApiAdminCompaniesVars>, 'data'> {
  data?: AdminCompaniesData;
  fetchingMore: boolean;
}
export const DEFAULT_PAGE = 1;
export const ADMIN_COMPANIES_PAGE_SIZE = 15;
export const DEFAULT_ADMIN_COMPANIES_VARS: AdminCompaniesVars = {
  sortBy: undefined,
  id: undefined,
  name: undefined
};
export function isAdminCompaniesSorting(u: unknown): u is AdminCompaniesSortVars {
  return isObject(u) && 'sort' in u && 'column' in u && isAdminCompaniesSortField(u.column) && isAdminSorts(u.sort);
}
export function isAdminCompaniesSearch(u: unknown): u is AdminCompaniesSearchVars {
  return isObject(u) && (('name' in u && isString(u.name)) || ('id' in u && isString(u.id)));
}
const ADMIN_COMPANIES_SORT_FIELDS = [
  'createdOn',
  'companyName',
  'orgNumber',
  'id',
  'pricePlan',
  'featureRoles'
] as const;
export type AdminCompaniesSortField = (typeof ADMIN_COMPANIES_SORT_FIELDS)[number];
export function isAdminCompaniesSortField(u: unknown): u is AdminCompaniesSortField {
  return (
    u === 'orgNumber' ||
    u === 'createdOn' ||
    u === 'companyName' ||
    u === 'id' ||
    u === 'pricePlan' ||
    u === 'featureRoles'
  );
}
